module.exports = __webpack_public_path__ + "static/media/telephone.89120d25.svg";